<template>
  <BigPopModel ref="popModelRef" @clearData="clearData()">
    <div class="tableContainer">
      <div class="searchContentContainer">
        <div class="searchItemContainer">
          <label for="CapitalAccountName" class="searchinputLabel">账户名称:</label>
          <div class="searchInputBox"><input type="text" class="searchinput" id="CapitalAccountName" v-model="searchItemList2.CapitalAccountName.defaultValue" @blur="unbindBpEnter()" @mousedown="bindBpEnter"></div>
        </div>
        <div class="FuncButton" @click="searchList()">搜索</div>
      </div>
      <TableShowForPop :tableTile="tableTile" :sendBackFildsName="sendBackFildsName" ref="tableShowForPopRef" @getPopValue="getPopValue" @clearData="clearData"></TableShowForPop>
    </div>
  </BigPopModel>
</template>

<script>
import { inject, onMounted, onUnmounted, provide, reactive, ref } from 'vue-demi'
import BigPopModel from '@/components/Common/BigPopModel.vue';
import TableShowForPop from '@/components/Content/MainBodyContent/TableShowForPop.vue';
import { useStore } from "vuex";
import InputPop from '@/hooks/InputPop';
export default {
  components: {
    BigPopModel,
    TableShowForPop
  },
  props:['tableTile'],
  setup(props) {
    const tableTile = props.tableTile;
    let { store, searchItemList, popModelRef, tableShowForPopRef, listForValidation, filterList, openPopComm, closePopComm, searchList, bindBpEnter, unbindBpEnter } = InputPop()

    const tableTitle = ref('选择资金账户')
    const sendBackFildsName = reactive({
      sendBackName: 'capitalAccountName',
    })
    const TableName = 'CapitalAccountList';
    let searchItemList2 = store.state.loginInitializeData.pageNameManage.filter(x => x.tableName == TableName)[0]

    const getPopValue = (value) => {
      searchItemList.documentContent.CapitalAccountId = value
      closePopComm()
    }

    searchItemList2.typeJudge = 'Ca'

    provide('searchItemList2', searchItemList2)

    provide('tableTitle', tableTitle)

    //#region 公式定义区
    //将表格相关数据连接进数据主线
    const fillSearchItemList = () => {
      const list = listForValidation.filter(x => x.tableNameForVali == searchItemList2.tableName && x.validateMethod == 'add')
      for (let item of list) {
        searchItemList2[item.fieldsNameForVali] = item
        for (let fkey in filterList) {
          if (item.fieldsNameForVali == fkey) {
            searchItemList2[item.fieldsNameForVali].Filter = filterList[fkey]
          }
        }
      }
    }

    const sendMsgSolve = (msg) => {
      searchItemList2.CapitalAccountName.defaultValue = msg
    }

    const clearData = () => {
      searchItemList2.CapitalAccountName.defaultValue = ''
    }

    //#endregion

    //#region 数据提供区

    //#endregion

    //#region 挂载前加载
    fillSearchItemList()
    //#endregion

    //#region 监控区

    //#endregion

    //#region 失去活跃处理

    //#endregion

    //#region 活跃时处理

    //#endregion

    //#region 离开时处理
    //#endregion

    return {
      popModelRef,
      openPopComm,
      closePopComm,
      tableShowForPopRef,
      searchList,
      sendBackFildsName,
      getPopValue,
      searchItemList,
      bindBpEnter,
      unbindBpEnter,
      sendMsgSolve,
      searchItemList2,
      fillSearchItemList,
      clearData,tableTile

    }
  }
}
</script>

<style scoped lang="less">
</style>